export interface Category {
  id: number;
  name: string;
  url: string;
  isSearch: boolean;
}

export const categories: Category[] = [
  { id: 1, name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', isSearch: false },
  { id: 2, name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html', isSearch: false },
  { id: 3, name: 'T-Shirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html', isSearch: false },
  { id: 4, name: 'Jackets', url: 'https://kaspreadsheet.com/category-914-Jackets.html', isSearch: false },
  { id: 5, name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html', isSearch: false },
  { id: 6, name: 'Headwear', url: 'https://kaspreadsheet.com/category-916-Headwear.html', isSearch: false },
  { id: 7, name: 'Sets', url: 'https://kaspreadsheet.com/category-917-Sets.html', isSearch: false },
  { id: 8, name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html', isSearch: false },
  { id: 9, name: 'Jersey', url: 'https://kaspreadsheet.com/category-919-Jersey.html', isSearch: false },
  { id: 10, name: 'Accessories', url: 'https://kaspreadsheet.com/category-920-Accessories.html', isSearch: false },
  { id: 11, name: 'Bags', url: 'https://kaspreadsheet.com/category-921-Bags.html', isSearch: false },
  { id: 12, name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Bags.html', isSearch: true },
  { id: 13, name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Bags.html', isSearch: true },
  { id: 14, name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Bags.html', isSearch: true },
];

export const featuredCategories: Category[] = [
  categories[0], // Shoes
  categories[1], // Hoodies/Sweaters
  categories[2], // T-Shirts
  categories[3], // Jackets
  categories[4], // Pants/Shorts
  categories[5], // Headwear
];